// write an events catalogue for the claim webcomponent
const UNLOCK_EVENT_STARTED = 'fp-unlock-started'
const UNLOCK_EVENT_UNLOCK = 'fp-unlock'
const UNLOCK_EVENT_UNLOCK_COMPLETE = 'fp-unlock-complete'
const MOBILE_DATA = 'fp-mobile-data'
const UNLOCK_EVENT_MODAL_OPEN = 'fp-unlock-modal-open'
const UNLOCK_EVENT_MODAL_CLOSE = 'fp-unlock-modal-close'

export enum UnlockEvents {
  Started = UNLOCK_EVENT_STARTED,
  Unlocked = UNLOCK_EVENT_UNLOCK,
  UnlockComplete = UNLOCK_EVENT_UNLOCK_COMPLETE,
  MobilePassData = MOBILE_DATA,
  ModalOpen = UNLOCK_EVENT_MODAL_OPEN,
  ModalClose = UNLOCK_EVENT_MODAL_CLOSE
}

export type FPUnlock = CustomEvent<Record<PropertyKey, string | null | boolean | undefined>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [UnlockEvents.Unlocked]: FPUnlock;
    }
}

export type FPUnlockComplete = CustomEvent<Record<PropertyKey, string | null | boolean | undefined>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [UnlockEvents.UnlockComplete]: FPUnlockComplete;
    }
}

export type FPUnlockMobilePass = CustomEvent<Record<PropertyKey, string | null | boolean | undefined | object>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [UnlockEvents.MobilePassData]: FPUnlockMobilePass;
    }
}


export type FPSTARTED = CustomEvent<Record<PropertyKey, never>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [UnlockEvents.Started]: FPSTARTED;
    }
}

export type FPUnlockModalOpen = CustomEvent<Record<PropertyKey, never>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [UnlockEvents.ModalOpen]: FPUnlockModalOpen;
    }
}

export type FPUnlockModalClose = CustomEvent<Record<PropertyKey, never>>;
declare global {
    interface GlobalEventHandlersEventMap {
        [UnlockEvents.ModalClose]: FPUnlockModalClose;
    }
}